import TableAutogestion from './TableAutogestion';
export default TableAutogestion;
